/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT BANNERS PAGE
 -----------------------------------------*/
import ImageInputAdminManager from '../../../admin/js/components/ImageInputAdminManager';

let BannerVariants = (() => {
    const $urlDeleteField = '/content/banners';
    const $urlGetVariant = '/content/banners/get_new_variant';
    const $buttonAdd = '#banner__add-variant';
    const $classButtonDelete = '.js-delete-variant';
    const $containerOfVariants = '#admin-banner-variants__parent';

    let init = () => {
        listenAdd();
        listenDelete();
    };

    /*
     |--------------------------------------------------------------------------
     | Adding new field
     |--------------------------------------------------------------------------
     */
    let listenAdd = () => {
        $(document).on('click', $buttonAdd, () => {
            let fieldIndex = $('.js-variant-container').length;
            AppendNewField(fieldIndex);
        });
    };

    let AppendNewField = (variantIndex) => {
        $.get($urlGetVariant, {variantIndex: variantIndex}).done( (response) => {
            $($containerOfVariants).append(response);
            (new ImageInputAdminManager()).init();
        });
    };

    /*
     |--------------------------------------------------------------------------
     | Deleting given field
     |--------------------------------------------------------------------------
     */
    let listenDelete = () => {
        $(document).on('click', $classButtonDelete, function () {
            console.log('Deleting called!');
            let variant = $(this).parents('.js-variant-container');
            let bannerId;
            if (bannerId = variant.data('banner-id')) {
                deleteFromDb(bannerId, variant);
                return true;
            }

            deleteLocal(variant);
        });
    };

    let deleteFromDb = (bannerId, variant) => {
        if (confirm('Вы уверены, что хотите удалить это поле?')) {
            $.ajax({
                url: $urlDeleteField + '/' + bannerId + '/variant/' + variant.data('variant-id'),
                method: 'POST',
                data: {
                    _method: 'DELETE'
                }
            }).done(() => {
                deleteLocal(variant);
            });
        }
    };

    let deleteLocal = (variant) => {
        variant.remove();
    };

    return {
        init: init
    }
})();

export default BannerVariants;
